module.exports = __webpack_public_path__ + "static/media/apartment5.4c1a66ee.jpg";